import * as React from "react";
import { Button, Form, Modal, ModalBody, ModalFooter, ModalTitle } from "react-bootstrap";
import { withTranslation, WithTranslation } from "react-i18next";
import { Field, InjectedFormProps, reduxForm } from "redux-form";
import { initialize } from "redux-form";
import { IInstitutePasswordChangeRequest } from "../store/institute/types";
import BootstrapFormGroup from "./BootstrapFormGroup";

interface IChangeInstitutePasswordModalFormProps {
  show: boolean;
  onHide: () => void;
}

class ChangeInstitutePasswordModalForm extends React.Component<InjectedFormProps<IInstitutePasswordChangeRequest, IChangeInstitutePasswordModalFormProps> & WithTranslation & IChangeInstitutePasswordModalFormProps> {
  public render() {
    const { pristine, submitting, handleSubmit, t, show, onHide } = this.props;
    return (
      <Modal show={show} onHide={onHide}>
        <Form onSubmit={handleSubmit}>
          <Modal.Header closeButton>
            <ModalTitle>{t("pages.passwordChange.title")}</ModalTitle>
          </Modal.Header>
          <ModalBody>
            <Field
                name="password"
                component={BootstrapFormGroup}
                label = {t("pages.passwordChange.newPassword")}
                placeholder = {t("pages.passwordChange.editor.newPasswordPlaceholder")}
                type = "password"
            />
            <Field
                name="passwordRepeat"
                component={BootstrapFormGroup}
                label = {t("pages.passwordChange.newPasswordRepeat")}
                placeholder = {t("pages.passwordChange.editor.newPasswordRepeatPlaceholder")}
                type = "password"
            />
          </ModalBody>
          <ModalFooter>
            <Button variant="primary" type="submit" disabled={pristine || submitting}>
              {t("form.general.changePassword")}
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
    );
  }
}

export const initChangeInstitutePasswordModalFormAction = (request: Partial<IInstitutePasswordChangeRequest>) => {
  return initialize("institutePasswordChangeFormModal", request);
};

export default reduxForm<IInstitutePasswordChangeRequest, IChangeInstitutePasswordModalFormProps>({
  form: "institutePasswordChangeFormModal",
  enableReinitialize: true,
})(withTranslation()(ChangeInstitutePasswordModalForm));
